/**
 * Contains custom code we use throughout the website.
 *
 * > This is old code, but is still used globally
 */

// Embla Helpers
const emblaHelpers = {
  addDotBtnsAndClickHandlers: (emblaApi) => {
    const dotsNode = emblaApi.rootNode().parentElement.querySelector('.embla-dots')
    let dotNodes = []

    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="embla-dot" type="button"></button>')
        .join('')

      dotNodes = Array.from(dotsNode.querySelectorAll('.embla-dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      if (dotNodes[previous]) dotNodes[previous].classList.remove('active')
      if (dotNodes[selected]) dotNodes[selected].classList.add('active')
    }

    emblaApi
      .on('init', addDotBtnsWithClickHandlers)
      .on('reInit', addDotBtnsWithClickHandlers)
      .on('init', toggleDotBtnsActive)
      .on('reInit', toggleDotBtnsActive)
      .on('select', toggleDotBtnsActive)

    return () => {
      dotsNode.innerHTML = ''
    }
  }
}

/** Detect clicks + touches outside of an element, and add a callback to handle the events. */
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    this.event = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }

    document.body.addEventListener('click', this.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', this.event)
  },
})

/** Detects clicks vs. long presses. */
Vue.directive('click-or-long-press', {
  bind (el, binding) {
    let pressTimer = null
    let isLongPress = false

    const handlePressStart = () => {
      isLongPress = false
      pressTimer = setTimeout(() => {
        isLongPress = true
        // Call onLongPress if provided
        binding.value.onLongPress?.()
      }, binding.value?.delay || 300)
    }

    const handlePressEnd = () => {
      clearTimeout(pressTimer)

      if (!isLongPress) {
        // Call onClick callback
        if (typeof binding.value === 'function') {
          binding.value()
        } else {
          binding.value.onClick?.()
        }
      }
    }

    // Store handlers on element for cleanup
    el._pressHandlers = { handlePressStart, handlePressEnd, pressTimer }

    // Add listeners with capture
    el.addEventListener('pointerdown', handlePressStart, true)
    el.addEventListener('pointerup', handlePressEnd, true)
  },

  unbind (el) {
    if (el._pressHandlers) {
      clearTimeout(el._pressHandlers.pressTimer)
      el.removeEventListener('pointerdown', el._pressHandlers.handlePressStart, true)
      el.removeEventListener('pointerup', el._pressHandlers.handlePressEnd, true)
      delete el._pressHandlers
    }
  }
})
